import { render, staticRenderFns } from "./CreateRemitterGroupEmailCoupon.vue?vue&type=template&id=1f7745ae"
import script from "./CreateRemitterGroupEmailCoupon.vue?vue&type=script&lang=js"
export * from "./CreateRemitterGroupEmailCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports